import React, { useState } from "react";
import { IEpiProps, IFacet, ISearchResultsContainer } from "../models/vertex-search-page-models";
import { useVertexSearchContext } from "../reducers/vertex-search-page-provider";
import { SearchAnswerCitations } from "./search-answer-citations";

interface IProps {
    facet: IFacet;
    showFacet: boolean;
    handleFilterChange: (facetKey: string, value: string, checked: boolean) => void;
    checkedValues: string[]; 
    updateFacetsShowMoreState: (facetKey: string) => void;
    showAll: boolean
    updateFacetsAccordionClosedStateInContext: (facetKey: string) => void;
    accordionClosed: boolean
}

interface IContextProps {
    epiProps: IEpiProps
}

export const ShopFacet = (props: IProps) => {
    const { epiProps }: IContextProps = useVertexSearchContext();

    function getFacetNameToDisplay(): string {
        if (props.facet.key == "attributes.aap_product_type") {
            return epiProps.productTypeFiltersHeading;
        }
        if (props.facet.key == "attributes.aap_price_range") {
            return epiProps.priceFiltersHeading;
        }
        if (props.facet.key == "attributes.aap_topics") {
            return epiProps.topicFiltersHeading;
        }
        if (props.facet.key == "attributes.aap_credits") {
            return epiProps.creditTypeFiltersHeading;
        }
        return "";
    }

    function getSelectedFacetCountDisplay(): string {
        if (props.checkedValues && props.checkedValues.length > 0) {
            return `(${props.checkedValues.length})`;
        }
        return "";
    }

    let facetHeading = getFacetNameToDisplay();
    let selectedFacetCountDisplay = getSelectedFacetCountDisplay();

    let displayShowMoreShowLessToggle = props.showFacet ? props.facet.values.length > 10 : false;
    let facetValuesToShow = props.showAll ? props.facet.values : props.facet.values.slice(0, 10);

    if (props.showFacet) {
        return (
            <div className="search-facet-section">
                <button className={`search-facet-button ${props.accordionClosed ? "" : ""}`} aria-expanded={!props.accordionClosed} onClick={() => props.updateFacetsAccordionClosedStateInContext(props.facet.key)}>
                    <span>{facetHeading} {selectedFacetCountDisplay && selectedFacetCountDisplay.length > 0 ? selectedFacetCountDisplay : null}</span>
                    <svg className="svg-icon" aria-hidden="true" focusable="false">
                        <use xlinkHref="#icon-chevron-down"></use>
                    </svg>
                </button> 
                {
                    !props.accordionClosed && 
                    <React.Fragment>
                        <ul className="unlisted">
                            {facetValuesToShow.map((val) => {
                                const checkboxId = `${props.facet.key}-${val.value}`.replace(/\s+/g, '-');
                                const isChecked = props.checkedValues.includes(val.value);
                                return (
                                    <li className="search-facet-section-list-item">
                                        <input
                                            type="checkbox"
                                            id={checkboxId}
                                            value={val.value}
                                            checked={isChecked}
                                            onChange={e => props.handleFilterChange(props.facet.key, val.value, e.target.checked)}
                                        />
                                        <label className="search-facet-section-list-item-label" htmlFor={checkboxId}>
                                            <span>{val.value}</span> <span className="search-facet-section-list-item-label-count">({val.count})</span>
                                        </label>
                                    </li>
                                )
                            })}
                        </ul>
                            {displayShowMoreShowLessToggle && (
                                <button className="search-facet-section-more-button" type="button" onClick={() => props.updateFacetsShowMoreState(props.facet.key)}>
                                {props.showAll ? epiProps.filtersShowLessText : epiProps.filtersShowMoreText}
                            </button>
                        )}
                    </React.Fragment>
                }
                
                
            </div>
        )
    }

}